<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="150px"
      class="demo-ruleForm"
      style="height:50vh;overflow-y: scroll;"
    >
      <el-form-item label="食堂名称：" prop="diningRoomName">
        <span v-if="type == 'info'">{{ ruleForm.diningRoomName }}</span>
        <el-input
          v-else
          style="width:95%"
          v-model.trim="ruleForm.diningRoomName"
          placeholder="请输入食堂名称"
          size="small"
          :maxlength="18"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="食堂地址：" prop="diningRoomAddress">
        <span v-if="type == 'info'">{{ ruleForm.diningRoomAddress }}</span>
        <el-input
          v-else
          style="width:95%"
          v-model.trim="ruleForm.diningRoomAddress"
          placeholder="请输入食堂地址"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="所属安全小组：" prop="securityTeamInCharge">
        <span v-if="type == 'info'">{{ ruleForm.securityTeamName }}</span>
        <el-select
          v-else
          style="width:95%"
          size="small"
          v-model="ruleForm.securityTeamInCharge"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in securityTeamList"
            :key="item.securityTeamId"
            :label="item.securityTeamName"
            :value="item.securityTeamId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="食堂面积：">
        <span v-if="type == 'info'">{{ ruleForm.usableArea }}</span>
        <el-input
          v-else
          style="width:95%"
          v-model.trim="ruleForm.usableArea"
          placeholder="请输入食堂面积"
          size="small"
          clearable
        >
          <template slot="append">㎡</template>
        </el-input>
      </el-form-item>
      <el-form-item label="食堂负责人：" prop="canteenManagerId">
        <span v-if="type == 'info'">{{ ruleForm.userName }}</span>
        <el-cascader
          v-else
          size="small"
          placeholder="请选择食堂负责人"
          :options="personnelList"
          v-model="selectedUserData"
          @change="selectDepartmentHead"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item label="经营模式：">
        <template>
          <span v-if="type == 'info'">{{
            $Common.getDataName(
              canteenManagementPattern,
              ruleForm.businessModel
            )
          }}</span>
          <el-select
            v-else
            style="width:95%"
            size="small"
            v-model="ruleForm.businessModel"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in canteenManagementPattern"
              :key="item.id"
              :label="item.nameOne"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item label="员工数量：">
        <span v-if="type == 'info'">{{ ruleForm.canteenEmployees }}</span>
        <el-input
          v-else
          style="width:95%"
          v-model.trim="ruleForm.canteenEmployees"
          clearable
          size="small"
          placeholder="请输入员工数量"
        >
          <template slot="append">名</template></el-input
        >
      </el-form-item>
      <el-form-item label="摄像头数量：">
        <span v-if="type == 'info'">{{ ruleForm.numberCamerasCanteen }}</span>
        <el-input
          v-else
          style="width:95%"
          v-model.trim="ruleForm.numberCamerasCanteen"
          clearable
          size="small"
          placeholder="请输入摄像头数量"
        >
          <template slot="append">台</template></el-input
        >
      </el-form-item>
      <el-form-item label="上年度综合等级：">
        <template>
          <span
            :style="'color:' + colors[ruleForm.lastYearComprehensiveGrade]"
            v-if="type == 'info'"
            >{{
              $Common.getDataName(
                inspectLevel,
                ruleForm.lastYearComprehensiveGrade
              )
            }}</span
          >
          <el-select
            v-else
            style="width:95%"
            size="small"
            v-model="ruleForm.lastYearComprehensiveGrade"
            clearable
            placeholder="请选择上年度综合等级"
          >
            <el-option
              v-for="item in inspectLevel"
              :key="item.id"
              :label="item.nameOne"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item label="本次检查动态等级：">
        <template>
          <span
            :style="'color:' + colors[ruleForm.checkDynamicLevel]"
            v-if="type == 'info'"
            >{{
              $Common.getDataName(inspectLevel, ruleForm.checkDynamicLevel)
            }}</span
          >
          <el-select
            v-else
            style="width:95%"
            size="small"
            v-model="ruleForm.checkDynamicLevel"
            clearable
            placeholder="请选择本次检查动态等级"
          >
            <el-option
              v-for="item in inspectLevel"
              :key="item.id"
              :label="item.nameOne"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item label="厨房用气情况：">
        <template>
          <span v-if="type == 'info'">
            {{ $Common.getDataName(gasType, ruleForm.kitchenGasUsage) }}</span
          >
          <el-select
            v-else
            style="width:95%"
            size="small"
            v-model="ruleForm.kitchenGasUsage"
            clearable
            placeholder="请选择厨房用气情况"
          >
            <el-option
              v-for="item in gasType"
              :key="item.id"
              :label="item.nameOne"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item label="食堂照片：">
        <el-image
          v-if="type == 'info'"
          style="width:50px; height:50px"
          :src="$store.state.config.fileUrl + ruleForm.diningRoomPhotograph"
          :preview-src-list="ruleForm.srcList"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <head-portrait-up-load
          v-else
          :imageUrl="ruleForm.diningRoomPhotograph"
          @imageChange="footImageChange"
        ></head-portrait-up-load>
      </el-form-item>
      <el-form-item label="经营许可证：">
        <el-image
          v-if="type == 'info'"
          style="width:50px; height:50px"
          :src="$store.state.config.fileUrl + ruleForm.foodTradePermit"
          :preview-src-list="ruleForm.srcList"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <head-portrait-up-load
          v-else
          :imageUrl="ruleForm.foodTradePermit"
          @imageChange="PermitImageChange"
        ></head-portrait-up-load>
      </el-form-item>
     
    </el-form>
      <div style="text-align:right;margin-top:10px">
         <span slot="footer" size="large" v-if="type != 'info'">
        <el-button type="primary" size="small" @click="saveSubmit('ruleForm')"
          >提交</el-button
        >
        <el-button
          type="primary"
          size="small"
          plain
          @click="cencelSubmit('ruleForm')"
          >取消</el-button
        >
      </span>
      </div>
  </div>
</template>
<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "CanteenAddOrEdit",
  components: {
    HeadPortraitUpLoad
  },
  props: {
    defaultData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showBox: {
      type: Boolean,
      default: {
        return: false
      }
    },
    type: {
      type: String,
      default: {
        return: ""
      }
    }
  },
  computed: {
    canteenManagementPattern() {
      return this.$store.state.select.canteenManagementPattern; //经营模式
    },
    inspectLevel() {
      return this.$store.state.select.inspectLevel; //上年度综合等级
    },
    gasType() {
      return this.$store.state.select.gasType; //厨房用气情况
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    var num = /^[0-9]*[1-9][0-9]*$/;
    var checkNum = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!num.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      colors: ["#12CF28", "#122ECF", "#E01616"],
      ruleForm: {},
      securityTeamList: [], //所属安全小组
      personnelList: [], //食堂负责人列表
      selectedUserData: [], //食堂负责人默认值
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      rules: {
        diningRoomName: [{ required: true, message: " ", trigger: "blur" }],
        diningRoomAddress: [{ required: true, message: " ", trigger: "blur" }],
        canteenManagerId: [{ required: true, message: " ", trigger: "change" }],
        securityTeamInCharge: [
          { required: true, message: " ", trigger: "change" }
        ]
      },
      numberData: [
        "usableArea",
        "canteenEmployees",
        "numberCamerasCanteen"
      ]
    };
  },
  created() {
    this.getAllSecurityGroupList();
    this.change();
  },
  mounted() {},
  methods: {
    change() {
      this.ruleForm = Object.assign({}, this.defaultData);
      this.numberData.forEach((element) => {
        if (this.ruleForm[element] == 0) {
          this.ruleForm[element] = "";
        }
      });
      // console.log(this.ruleForm)
      this.getPersonnelList();
    },
    // 获取安全小组
    async getAllSecurityGroupList() {
      var paramData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getAllSecurityGroupList(paramData, true);
      if (res.code == 200) {
        this.securityTeamList = res.data;
      } else if (res.code == 101) {
        this.securityTeamList = [];
      } else {
        this.securityTeamList = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取食堂负责人列表
    async getPersonnelList() {
      let self = this;
      var paramData = {
        schoolId: self.$store.state.schoolId
      };
      let res = await self.$Http.getPersonnelList(paramData);
      if (res.code == 200) {
        let data = res.data || [];
        data.forEach((element) => {
          (element.value = element.departmentId),
            (element.label = element.departmentName),
            (element.children = element.userTableStructureList || []);
          element.children.forEach((eelement) => {
            eelement.label = eelement.userName;
            eelement.value = eelement.userId;
            eelement.phone = eelement.userPhone;
          });
        });
        self.personnelList = data;
        self.personnelList.forEach((item) => {
          item.children.forEach((iitem) => {
            if (iitem.value == self.ruleForm.canteenManagerId) {
              self.selectedUserData = [item.value, iitem.value];
            }
          });
        });
      } else if (res.code == 101) {
        self.personnelList = [];
      } else {
        self.personnelList = [];
        self.$message({
          type: "error",
          message: res.messsage || "部门人员获取失败"
        });
      }
    },
    selectDepartmentHead(val) {
      this.ruleForm.canteenManagerId = parseInt(val.slice(-1));
    },
    // 食堂照片
    footImageChange(src) {
      this.ruleForm.diningRoomPhotograph = src || "";
    },
    // 食品经营许可证
    PermitImageChange(src) {
      this.ruleForm.foodTradePermit = src || "";
    },
    //   提交
    saveSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    //   取消
    cencelSubmit(formName) {
      this.$refs[formName].resetFields();
      this.$emit("cencelSubmit");
    }
  },
  watch: {
    showBox: function(val) {
      this.$refs.ruleForm.resetFields();
      if (val) {
        this.change();
      } else {
        this.selectedUserData = [];
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
